import React, { PureComponent } from "react";
import PropTypes from "prop-types";

class Searching extends PureComponent {
    static propTypes = {
        theme: PropTypes.oneOf(["light", "dark"])
    };

    static defaultProps = {
        theme: "dark"
    };

    render() {
        const { theme } = this.props;

        return (
            <div className="searching">
                <div className="searching__inner">
                    <img
                        src={
                            theme === "dark"
                                ? require("~/images/decorative/spinner-dark.png")
                                : require("~/images/decorative/spinner-light.png")
                        }
                        className="searching__image"
                    />
                </div>
            </div>
        );
    }
}

export default Searching;



// WEBPACK FOOTER //
// ./public/assets/scripts/components/products/Searching.js